import * as React from 'react';

// export const BoardElement = memo(
//   ({ attributes, children, element, nodeProps }: StyledElementProps) => {
//     const readOnly = useReadOnly();
//     const selected = useSelected();
//     const { members, currentUser, editorId } = useSlatePluginsStore();
//     const editor = usePlateEditorRef(editorId) as BaseEditor;
//     const [locTitle, setLocTitle] = useState('');
//     const { columns = [], title = '' } = element;
//     const handleUpdateBoards = useCallback(
//       (args: { columns?: any; title?: any }) => {
//         const path = ReactEditor.findPath(editor as ReactEditor, element);
//         Transforms.setNodes(editor, { ..._.cloneDeep(args) } as Partial<Node>, {
//           at: path,
//         });
//       },
//       [editor, element]
//     );

//     const boards = useMemo(() => {
//       return (
//         <BoardsView
//           column={columns}
//           members={members}
//           currentUser={currentUser}
//           onSearchUsers={() => [] as any}
//           isReadOnly={readOnly}
//           apiCallbacks={{
//             onUpdateBoards: (e) => {
//               handleUpdateBoards({ columns: e.columns });
//             },
//           }}
//         />
//       );
//     }, [columns, members, currentUser, readOnly, handleUpdateBoards]);

//     useEffect(() => {
//       setLocTitle(title);
//     }, [title]);

//     const handleOnChangeTitle: React.ChangeEventHandler<HTMLInputElement> = (e) => {
//       setLocTitle(e.target.value);
//     };

//     const isBoardSelected = useMemo(
//       () => editor?.selection?.anchor.path !== editor?.selection?.focus.path && !!selected,
//       [editor?.selection, selected]
//     );

//     return (
//       <ErrorBoundary
//         FallbackComponent={() => (
//           <p contentEditable={false} className="bg-yellow-100 p-10">
//             <span role="img" aria-label="Warning emoji">
//               ⚠️
//             </span>{' '}
//             Something wrong with board! try remove and add new.
//           </p>
//         )}
//       >
//         {/* <div {...attributes} {...nodeProps}>
//           <div
//             contentEditable={false}
//             className={cn({
//               'border-blue-500 border-2 rounded-md': isBoardSelected,
//             })}
//           >
//             <input
//               placeholder="Untitled"
//               disabled={readOnly}
//               value={locTitle}
//               className="mb-14 placeholder-gray-500 text-base flex-grow w-full border-b border-gray-200 bg-transparent"
//               onChange={handleOnChangeTitle}
//               onBlur={() => handleUpdateBoards({ title: locTitle })}
//             />
//             {boards}
//           </div>
//           {children}
//         </div> */}
//       </ErrorBoundary>
//     );
//   }
// );

export const BoardElement = () => {
  return (
    <p className="bg-yellow-100 p-10">
      This board isn’t available any longer. Add a new Kanban board to your file
    </p>
  );
};
BoardElement.displayName = 'callout-element-base';
